// extracted by mini-css-extract-plugin
export default {"conteiner":"ToggleSelector_conteiner__q2bji","selected":"ToggleSelector_selected__-uiXe"};